import {filterMapperByKey} from 'api/mappers/filters';
import {apiClient} from 'core/apiClient';
import {
    AggregationChildrenCode,
    AggregationParentCode,
    DocumentAggregationData,
    ProductsGridAccessors,
} from 'types';

import {ApiFilters} from 'types/api';

export async function fetchParentCodesGrid(params: {
    paging: {pageSize: number; pageRef: string | null};
    identityCode: string | null;
    filters: ApiFilters;
    storageLocationId: number | null;
}) {
    const packagingTypeFilter = params.filters.find(
        (f) => f.id === ProductsGridAccessors.packageType,
    );
    if (packagingTypeFilter)
        packagingTypeFilter.value = filterMapperByKey(packagingTypeFilter.value, 'value');
    return (
        await apiClient.post<{nextPageRef: string; data: AggregationParentCode[]}>(
            'service/products/high-level-codes',
            params,
        )
    ).data;
}

export async function fetchChildrenCodesGrid(params: {
    paging: {pageSize: number; pageRef: string | null};
    identityCode?: string | null;
    filters: ApiFilters;
    storageLocationId: number | null;
}) {
    const packagingTypeFilter = params.filters.find(
        (f) => f.id === ProductsGridAccessors.packageType,
    );
    if (packagingTypeFilter)
        packagingTypeFilter.value = filterMapperByKey(packagingTypeFilter.value, 'value');

    return (
        await apiClient.post<{nextPageRef: string; data: AggregationChildrenCode[]}>(
            'service/products/low-level-codes',
            params,
        )
    ).data;
}

export async function fetchDocumentAggregationCreate(params: DocumentAggregationData) {
    if (params.file) return fetchDocumentAggregationCreateWithFile(params);
    const data = await apiClient.post('/marking/aggregation', {aggregate: [params]});
    return {data};
}

export async function fetchDocumentAggregationCreateWithFile(params: DocumentAggregationData) {
    const {aggregationType, ...payload} = params;
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => formData.append(key, value));
    const data = await apiClient.post('/marking/aggregation/upload', formData, {
        headers: {'Content-Type': 'multipart/form-data'},
    });
    return {data};
}
